import moment from "moment";
import { BASE_URL_API } from "../../../constants";
import fetcher from "../../../utils/fetcher";

export const _api_get_remotes = ({ start_date_iso_week }) => {
    return fetcher(
        `${BASE_URL_API}/working_outside/me/${start_date_iso_week}/list`,
        {
            method: "GET",
            credentials: "include",
        }
    );
};

export const _api_get_data_event_by_id = ({ event_id }) => {
    return fetcher(`${BASE_URL_API}/working_outside/item/${event_id}/details`, {
        method: "GET",
        credentials: "include",
    });
};

export const _api_add_day_remote = (data) => {
    const start_date = moment(data?.start_date).format("YYYY-MM-DD");
    const end_date = moment(data?.end_date).format("YYYY-MM-DD");
    const until_date = moment(data?.until_date).format("YYYY-MM-DD");
    const repeat = data?.repeat;
    const start_time = data?.start_time === 0 ? "AM-S" : "PM-S";
    const end_time = data?.end_time === 0 ? "AM-E" : "PM-E";

    return fetcher(
        repeat === 0
            ? `${BASE_URL_API}/working_outside/create`
            : `${BASE_URL_API}/working_outside/serie/create`,
        {
            method: "POST",
            credentials: "include",
            body: JSON.stringify({
                start_date,
                end_date,
                start_time,
                end_time,
                reason: data?.reason,
                until_date,
                repeat,
            }),
        }
    );
};

export const _api_update_day_remote = (data) => {
    const start_date = moment(data?.start_date).format("YYYY-MM-DD");
    const end_date = moment(data?.end_date).format("YYYY-MM-DD");
    const start_time = data?.start_time === 0 ? "AM-S" : "PM-S";
    const end_time = data?.end_time === 0 ? "AM-E" : "PM-E";
    const repeat = data?.repeat;
    const until_date = data?.until_date
        ? moment(data?.until_date).format("YYYY-MM-DD")
        : null;

    return data?.event_type.actualEvent
        ? fetcher(
              `${BASE_URL_API}/working_outside/item/${data?.event_id}/update`,
              {
                  method: "PUT",
                  credentials: "include",
                  body: JSON.stringify({
                      start_date,
                      end_date,
                      start_time,
                      end_time,
                      reason: data?.reason,
                      repeat: 0,
                  }),
              }
          )
        : fetcher(
              `${BASE_URL_API}/working_outside/serie/${data?.series}/update`,
              {
                  method: "PUT",
                  credentials: "include",
                  body: JSON.stringify({
                      start_date,
                      end_date,
                      start_time,
                      end_time,
                      reason: data?.reason,
                      until_date:
                          moment(data?.until_date).format("YYYY-MM-DD") ??
                          until_date,
                      repeat,
                  }),
              }
          );
};

export const _api_delete_day_remote = ({ event_id, serie }) => {
    const URL =
        event_id === serie
            ? `${BASE_URL_API}/working_outside/item/${event_id}/delete`
            : `${BASE_URL_API}/working_outside/serie/${serie}/delete`;
    return fetcher(URL, {
        method: "DELETE",
        credentials: "include",
    });
};
